import React, { FC } from 'react';

export const PaymentNetworks: FC = () => {
  return <div>PaymentNetworks</div>;
};
